import { render, staticRenderFns } from "./fb-gender-series.vue?vue&type=template&id=381d0060&scoped=true"
import script from "./fb-gender-series.vue?vue&type=script&lang=js"
export * from "./fb-gender-series.vue?vue&type=script&lang=js"
import style0 from "./fb-gender-series.vue?vue&type=style&index=0&id=381d0060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d0060",
  null
  
)

export default component.exports